// extracted by mini-css-extract-plugin
export default {"selectContainer":"InputInvoice_selectContainer__-RMhh","control":"InputInvoice_control__0iMl0","label":"InputInvoice_label__2hDn2","searchIcon":"InputInvoice_searchIcon__neGKO"};